// ABOUTME: Crossing list + Reset control for the child's own dashboard (slug+token access only).
// ABOUTME: Wraps useCrossings/ResetControl so ChildDashboardBasic doesn't call the hook
// ABOUTME: conditionally (Issue #1939).

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useCrossings } from '../../hooks/useCrossings';
import CrossingList from './CrossingList';
import CrossingEntryDialog from './CrossingEntryDialog';
import ResetControl from './ResetControl';

interface CrossingChildSectionProps {
  slug: string;
  token?: string;
  familyTimezone?: string;
}

export default function CrossingChildSection({ slug, token, familyTimezone }: CrossingChildSectionProps) {
  const { items, error, refetch } = useCrossings({ mode: 'child', slug, token, familyTimezone });
  const [openCrossingId, setOpenCrossingId] = useState<number | null>(null);
  const navigate = useNavigate();

  const handleStarted = (crossingId: number) => {
    refetch();
    setOpenCrossingId(crossingId);
  };

  const handleConfirm = (crossingId: number) => {
    const query = token
      ? `?slug=${encodeURIComponent(slug)}&token=${encodeURIComponent(token)}`
      : `?slug=${encodeURIComponent(slug)}`;
    navigate(`/crossing/${crossingId}${query}`);
  };

  return (
    <>
      <ResetControl slug={slug} token={token} onStarted={handleStarted} />
      {error ? (
        <Typography variant="body2" color="error">Couldn&apos;t load your crossings — try again in a moment</Typography>
      ) : (
        <CrossingList items={items} onOpen={setOpenCrossingId} />
      )}
      {openCrossingId != null && (
        <CrossingEntryDialog
          open
          crossingId={openCrossingId}
          onDismiss={() => setOpenCrossingId(null)}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
}
